var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-1H9V9H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB5B8",
    d: "M4.733 3.013l2.999-.948.45 1.18-3.02.947 1.927 2.55-1.028.758-1.97-2.612L2.12 7.5l-1.029-.758 1.928-2.55L0 3.244l.45-1.18 2.998.949V0h1.285z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterix);
export default __webpack_public_path__ + "static/media/asterix.3eef0d78d00c523e51c4bbde36aaf347.svg";
export { ForwardRef as ReactComponent };